import { ToggleButton } from "@mui/material";
import { ApplicationTooltip } from "../views";

type ModuleButtonProps = {
    tooltipText: string;
    disabled: boolean;
    onChanged: () => void;
    children: React.ReactElement;
};

export function ToolsPanelButton({
    tooltipText,
    disabled,
    onChanged,
    children,
}: ModuleButtonProps) {
    return (
        <ApplicationTooltip
            title={tooltipText}
            placement='bottom-start'
        >
            <ToggleButton
                value="check"
                selected={true}
                onChange={onChanged}
                sx={{
                    borderColor: "#9e9d9d",
                    '&.Mui-selected': {
                        backgroundColor: '#cdcdcd',
                    },
                    '&.Mui-disabled': {
                        color: '#828282',
                    },
                    height: '5px',
                    width: '5px',
                }}
                disabled={disabled}
            >
                {children}
            </ToggleButton>
        </ApplicationTooltip>
    );
}